import React from 'react';
import Typist from 'react-typist';

const Icon1 = () => (
  <svg
    className="auth0-lock-icon"
    height="13px"
    version="1.1"
    viewBox="0 0 32 26"
    width="14px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd" id="Page-1" stroke="none" strokeWidth="1">
      <g fill="#373A39" id="32px" transform="translate(-2155.000000, -2317.000000)">
        <g id="Group-856" transform="translate(1.000000, 1.000000)">
          <path
            d="M2184,2339 C2184,2339.55 2183.55,2340 2183,2340 L2157,2340 C2156.45,2340 2156,2339.55 2156,2339 L2156,2319 C2156,2318.45 2156.45,2318 2157,2318 L2183,2318 C2183.55,2318 2184,2318.45 2184,2319 L2184,2339 L2184,2339 Z M2184,2316 L2156,2316 C2154.89,2316 2154,2316.89 2154,2318 L2154,2340 C2154,2341.1 2154.89,2342 2156,2342 L2184,2342 C2185.1,2342 2186,2341.1 2186,2340 L2186,2318 C2186,2316.89 2185.1,2316 2184,2316 L2184,2316 Z M2176,2322 L2180,2322 L2180,2326 L2176,2326 L2176,2322 Z M2174,2328 L2182,2328 L2182,2320 L2174,2320 L2174,2328 Z M2158,2332 L2172,2332 L2172,2330 L2158,2330 L2158,2332 Z M2158,2336 L2172,2336 L2172,2334 L2158,2334 L2158,2336 Z"
            id="Fill-419"
          />
        </g>
      </g>
    </g>
  </svg>
);

const Icon2 = () => (
  <svg
    className="auth0-lock-icon auth0-lock-icon-box"
    height="14px"
    version="1.1"
    viewBox="0 0 13 16"
    width="11px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g fill="#888888" transform="translate(-288.000000, -1508.000000)">
        <path d="M299,1523.998 L290,1523.998 C288.896,1523.998 288,1523.102 288,1521.999 L288,1515.999 C288,1514.895 288.896,1513.998 290,1513.998 L290,1513.998 L290,1512.499 C290,1510.015 292.015,1507.999 294.5,1507.999 C296.985,1507.999 299,1510.015 299,1512.499 L299,1513.999 C300.104,1513.999 301,1514.895 301,1515.999 L301,1521.999 C301,1523.103 300.104,1523.998 299,1523.998 L299,1523.998 Z M298,1512.499 C298,1510.566 296.433,1508.999 294.5,1508.999 C292.567,1508.999 291,1510.566 291,1512.499 L291,1513.998 L298,1513.998 L298,1512.499 L298,1512.499 Z M300,1515.999 C300,1515.446 299.552,1514.998 299,1514.998 L290,1514.998 C289.447,1514.998 289,1515.446 289,1515.999 L289,1521.999 C289,1522.551 289.447,1522.998 290,1522.998 L299,1522.998 C299.552,1522.998 300,1522.551 300,1521.999 L300,1515.999 L300,1515.999 Z M294.5,1520.998 C294.224,1520.998 294,1520.774 294,1520.498 L294,1517.498 C294,1517.223 294.224,1516.999 294.5,1516.999 C294.776,1516.999 295,1517.223 295,1517.498 L295,1520.498 C295,1520.774 294.776,1520.998 294.5,1520.998 L294.5,1520.998 Z" />
      </g>
    </g>
  </svg>
);

const Credentials = ({ values, placeholders, typing1, typing2, onDone1, onDone2, focused }) => (
  <div className="auth0-lock-view-content">
    <div className="auth0-lock-body-content">
      <div className="auth0-lock-content">
        <div className="auth0-lock-form">
          <div className="auth0-lock-tabs-container" />
          <div className="auth0-lock-pane-separator" />
          <div>
            <div className="auth0-lock-input-block auth0-lock-input-email">
              <div
                className={`auth0-lock-input-wrap auth0-lock-input-wrap-with-icon ${focused === 1 ? 'auth0-lock-focused' : ''}`}
              >
                <span><Icon1 /></span>
                <span className="auth0-lock-input">
                  {typing1 &&
                    <Typist cursor={{ show: false }} onTypingDone={onDone1} avgTypingDelay={85}>
                      {values.user}
                    </Typist>}
                </span>
              </div>
            </div>
            <div className="auth0-lock-input-block auth0-lock-input-password">
              <div
                className={`auth0-lock-input-wrap auth0-lock-input-wrap-with-icon ${focused === 2 ? 'auth0-lock-focused' : ''}`}
              >
                <span><Icon2 /></span>
                <span className="auth0-lock-input">
                  <span className="auth0-lock-input-placeholder">{placeholders.pwd}</span>
                  {typing2 &&
                    <Typist cursor={{ show: false }} onTypingDone={onDone2} avgTypingDelay={85}>
                      {values.pwd}
                    </Typist>}
                </span>
              </div>
            </div>
            <p className="auth0-lock-alternative">
              <a className="auth0-lock-alternative-link" href="#">Dont remember your password?</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Credentials;



// WEBPACK FOOTER //
// ./src/components/LockDeviceType/components/Credentials.js